export const isNullOrUndefined = (val: any) => {
  return val === undefined || val === null;
};
